module.exports = __webpack_public_path__ + "static/media/SaludPsico_Categoria_512.23e7af28.png";